export const LOCAL_STORAGE_FIELDS = {
    token: 'auth-token',
    user:  'user-profile'
};
